import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Router, ActivatedRoute } from "@angular/router";
import { CustomHttp } from "../../../common/customHttp.service";
import { ApiUrl } from "../../../common/apiUrls";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ValidationService } from "../../../common/validationservice";
import { MainAppComponent } from "../../../layout/layout.component";
import { PagerService } from "../../../common/pagerService";
import { UserTypeModel } from "../../../common/viewModels/Admin/UserModel";
import { LabModel } from "../../../common/viewModels/Admin/LabModel";
import {
  CompanyDataModel,
  CustomerModel,
} from "../../../common/viewModels/Admin/CustomerModel";
import { RolesModel } from "../../../common/viewModels/Admin/UserModel";
import { UserCred } from "../../../common/viewModels/Admin/UserModel";
import { UserTypes } from "../../../common/enumcontainer.enum";
import "rxjs/add/operator/map";
import { D, O } from "@angular/cdk/keycodes";
declare var $: any;

@Component({
  selector: "app-addedituser",
  templateUrl: "./addedituser.component.html",
  styleUrls: ["./addedituser.component.scss"],
})
export class AddedituserComponent implements OnInit {
  userTypes: UserTypeModel;
  labs: LabModel[];
  customers: CustomerModel[];
  changePassword: UserCred = new UserCred();
  roles: RolesModel[];
  userForm: FormGroup;
  reasetPasswordForm: FormGroup;
  isEdit: boolean = false;
  isResetSubmit: boolean = false;
  isSubmitted: boolean = false;
  id: string;
  showLabs: boolean = true;
  showCustomers: boolean = false;
  companyMand: boolean = true;
  disableUserType: boolean = false;
  showCompanyErrorMsg: boolean = false;
  showDialogu: boolean = false;
  companySearchText: string = "";
  selectedCompanyData: CompanyDataModel = new CompanyDataModel();
  filteredCompanyData: CompanyDataModel = new CompanyDataModel();
  constructor(
    public _router: Router,
    private _mApp: MainAppComponent,
    private formBuilder: FormBuilder,
    private _pageSrvc: PagerService,
    private _http: CustomHttp,
    private _appUrl: ApiUrl,
    private _route: ActivatedRoute,
    private _validationService: ValidationService,
    private _toastrService: ToastrService,
  ) {}

  ngOnInit() {
    this.GetUserTypes();
    this.GetLabs();
    this.GetCustomers();
    let userId = this._route.snapshot.params["id"];
    if (userId != "" && userId != null && userId != undefined) {
      this.createEditUserForm();
      this.isEdit = true;
      this._mApp.ShowLoader();
      this.disableUserType = true;
      this.getUserDetailsById(userId);
    } else {
      this.createAddUserForm();
    }
    this.createResetPasswordForm();
  }

  createAddUserForm() {
    this.userForm = this.formBuilder.group({
      UserId: [0],
      UserTypeId: [
        "",
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      CompanyId: [
        "",
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      DefaultCompanyId: [0, Validators.required],
      LabIds: [
        "",
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      FirstName: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(30),
        ]),
      ],
      LastName: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(30),
        ]),
      ],
      UserName: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(30),
        ]),
      ],
      Email: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
          Validators.pattern(this._validationService.emailPattern),
        ]),
      ],
      RoleId: [
        "",
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      OrgId: [""],
      passwords: this.formBuilder.group(
        {
          // Password: ['', Validators.compose([Validators.required,Validators.pattern(this._validationService.passwordPattern)])],
          Password: [
            "",
            Validators.compose([
              Validators.required,
              Validators.minLength(6),
              Validators.maxLength(15),
            ]),
          ],
          ConfirmPassword: ["", Validators.compose([Validators.required])],
        },
        { validator: this._validationService.PasswordMatch },
      ),
    });
  }

  createResetPasswordForm() {
    this.reasetPasswordForm = this.formBuilder.group({
      UserId: ["0"],
      passwords: this.formBuilder.group(
        {
          Password: [
            "",
            Validators.compose([
              Validators.required,
              Validators.minLength(6),
              Validators.maxLength(15),
            ]),
          ],
          ConfirmPassword: ["", Validators.compose([Validators.required])],
        },
        { validator: this._validationService.PasswordMatch },
      ),
    });
  }

  createEditUserForm() {
    this.userForm = this.formBuilder.group({
      UserId: [0],
      UserTypeId: [
        "",
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      LabIds: [""],
      CompanyId: [""],
      DefaultCompanyId: [0],
      FirstName: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(30),
        ]),
      ],
      LastName: [
        "",
        Validators.compose([Validators.minLength(1), Validators.maxLength(30)]),
      ],
      UserName: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(30),
        ]),
      ],
      Email: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(this._validationService.emailPattern),
        ]),
      ],
      RoleId: [
        "",
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      OrgId: [""],
    });
  }

  getUserDetailsById(userId: string) {
    this._http.get(this._appUrl.GetUserByUserId + userId).subscribe(
      (data) => {
        this._mApp.HideLoader();
        var userData = data.json().Result;
        this.GetRoles(userData.UserTypeId);
        //this.userForm.setValue(userData);

        const sCompanyIds =
          userData.CompanyData && userData.CompanyData.Company.map((x: any) => x.CompanyId) || [];
        this.selectedCompanyData = userData.CompanyData || new CompanyDataModel();
        this.filteredCompanyData = { ...this.selectedCompanyData };
        switch (userData.UserTypeId) {
          case UserTypes.LabUser:
            this.userForm.controls["LabIds"].setValidators(
              Validators.compose([
                Validators.required,
                this._validationService.ValidateMultiCheckDropDown,
              ]),
            );
            this.showLabs = true;
            this.showCustomers = false;
            if(!this.labs){
              break;
            }
            for (let item of this.labs) {
              if (item.LabId == userData.CompanyId) {
                this.userForm.controls["CompanyId"].setValue(
                  userData.CompanyId,
                );
                break;
              } else this.userForm.controls["CompanyId"].setValue(null);
            }
            break;
          case UserTypes.ClientUser:
            this.userForm.controls["CompanyId"].setValidators(
              Validators.compose([
                Validators.required,
                this._validationService.ValidateDropdownList,
              ]),
            );
            this.showLabs = false;
            this.showCustomers = true;
            if (!sCompanyIds.length || !this.customers) {
              break;
            }

            if (sCompanyIds.length > 0) {
              this.userForm.controls["CompanyId"].setValue(sCompanyIds);
            } else {
              this.userForm.controls["CompanyId"].setValue(null);
            }
            break;
        }
        const udata = {
          UserId: userData.UserId,
          UserName: userData.UserName,
          FirstName: userData.FirstName,
          LastName: userData.LastName,
          Email: userData.Email,
          UserTypeId: userData.UserTypeId,
          CompanyId: sCompanyIds.length > 0 ? sCompanyIds : null,
          DefaultCompanyId: this.selectedCompanyData.DefaultCompanyId || 0,
          LabIds: userData.LabIds,
          RoleId: userData.RoleId,
          OrgId: userData.OrgId,
        };
        this.userForm.setValue(udata);
        delete userData["Password"];
        delete userData["ConfirmPassword"];
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result);
      },
    );
  }

  GetUserTypes() {
    this._http.get(this._appUrl.GetUserTypes).subscribe(
      (data) => {
        if (data.json().Result != null) this.userTypes = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json().Result, "");
      },
    );
  }

  GetLabs() {
    this._http.get(this._appUrl.GetLabsMinInfoList).subscribe(
      (data) => {
        let lstLabs = data.json().Result;
        if (this._mApp.currentUserLabIds && lstLabs)
          lstLabs = lstLabs.filter((m) =>
            this._mApp.currentUserLabIds.includes(m.LabId),
          );
        this.labs = lstLabs;
      },
      (error) => {
        this._toastrService.error(error.json().Result, "");
      },
    );
  }

  GetCustomers() {
    this._http.get(this._appUrl.GetCustomersMinInfoList).subscribe(
      (data) => {
        if (data.json().Result != null) this.customers = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json().Result, "");
      },
    );
  }

  GetRoles(id: number) {
    this._http.get(this._appUrl.GetRoles + id).subscribe(
      (data) => {
        this.roles = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json().Result, "");
      },
    );
  }

  onCompanySelectionChange(selectedIds: number[]) {
    // Build company data array from selected customers
    const companyArray = this.customers
      .filter((c: any) => selectedIds && selectedIds.includes(c.CustomerId))
      .map((c: any) => ({
        CompanyId: c.CustomerId,
        CompanyName: c.Name,
      }));

    // Update selectedCompanyData
    if (!this.filteredCompanyData) {
      this.filteredCompanyData = new CompanyDataModel();
    }
    this.filteredCompanyData.Company = companyArray;
    this.selectedCompanyData.Company = companyArray;

    // Auto-select first company as default if no default is set
    // if (companyArray.length > 0) {
    //   const defaultControl = this.userForm.get('DefaultCompanyId');
    //   const currentDefault = defaultControl ? defaultControl.value : 0;
    //   if (!currentDefault || currentDefault === 0) {
    //     this.filteredCompanyData.DefaultCompanyId = companyArray[0].CompanyId;
    //     this.filteredCompanyData.DefaultCompanyName = companyArray[0].CompanyName;
    //     this.userForm.controls["DefaultCompanyId"].setValue(companyArray[0].CompanyId);
    //   } else if (!companyArray.some((c: any) => c.CompanyId === currentDefault)) {
    //     // Reset if current default is not in selected
    //     this.filteredCompanyData.DefaultCompanyId = companyArray[0].CompanyId;
    //     this.filteredCompanyData.DefaultCompanyName = companyArray[0].CompanyName;
    //     this.userForm.controls["DefaultCompanyId"].setValue(companyArray[0].CompanyId);
    //   }
    // } else {
    //   this.filteredCompanyData.DefaultCompanyId = 0;
    //   this.filteredCompanyData.DefaultCompanyName = "";
    //   this.userForm.controls["DefaultCompanyId"].setValue(0);
    // }
  }

  bindCompanyData(val: number) {
    this.userForm.controls["CompanyId"].setValue(null);
    this.userForm.controls["DefaultCompanyId"].setValue(0);
    this.userForm.controls["LabIds"].setValue(null);
    this.filteredCompanyData.Company = [];
    this.filteredCompanyData.DefaultCompanyId = 0;
    this.filteredCompanyData.DefaultCompanyName = "";
    this.GetRoles(val);
    switch (val) {
      case UserTypes.SuperUser:
        this.showCustomers = false;
        this.showLabs = false;
        break;
      case UserTypes.LabUser:
        this.showCustomers = false;
        this.showLabs = true;
        this.userForm.controls["LabIds"].setValidators(
          Validators.compose([
            Validators.required,
            this._validationService.ValidateMultiCheckDropDown,
          ]),
        );
        this.userForm.controls["LabIds"].updateValueAndValidity();
        this.userForm.controls["CompanyId"].setValidators(null);
        this.userForm.controls["CompanyId"].updateValueAndValidity();
        //this.GetLabs();
        break;
      case UserTypes.ClientUser:
        this.showCustomers = true;
        this.showLabs = false;
        this.userForm.controls["CompanyId"].setValidators(
          Validators.compose([
            Validators.required,
            this._validationService.ValidateDropdownList,
          ]),
        );
        this.userForm.controls["CompanyId"].updateValueAndValidity();
        this.userForm.controls["LabIds"].setValidators(null);
        this.userForm.controls["LabIds"].updateValueAndValidity();
        //this.GetCustomers();
        break;
    }
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.userForm.valid) {
      const defaultCompanyId = this.userForm.controls["DefaultCompanyId"].value;
      const selectedCompanyIds = this.userForm.controls["CompanyId"].value || [];
      if(defaultCompanyId === 0 && selectedCompanyIds.length > 1){
        $('#changeDefaultCompany').modal('show');
        return;
      }
      else if (defaultCompanyId === 0 && selectedCompanyIds.length === 1) {
        this.userForm.controls["DefaultCompanyId"].setValue(selectedCompanyIds[0]);
      }
      this._mApp.ShowLoader();
      let userDetails = this.userForm.value;
      
      // Include CompanyData if customer user type
      userDetails.CompanyData = this.selectedCompanyData.DefaultCompanyId;
      if (userDetails.UserTypeId === UserTypes.ClientUser && this.selectedCompanyData.Company && this.selectedCompanyData.Company.length > 0) {
        userDetails.CompanyId = this.selectedCompanyData.Company.map((c: any) => c.CompanyId);
      }
      
      if (!this.isEdit)
        userDetails.Password = this.userForm.value.passwords.Password;
      
      this._http.post(this._appUrl.AddUser, userDetails).subscribe(
        (data) => {
          this._mApp.HideLoader();
          this._toastrService.success(data.json().Result, "");
          this._router.navigate(["/userlist"]);
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        },
      );
    }
  }

  resetPassword() {
    this.reasetPasswordForm.reset();
    this.reasetPasswordForm.markAsPristine();
    this.reasetPasswordForm.markAsUntouched();
    this.reasetPasswordForm.clearAsyncValidators();
  }

  Resetpassword() {
    this.isResetSubmit = true;
    if (this.reasetPasswordForm.valid) {
      this.changePassword.UserPwd =
        this.reasetPasswordForm.value.passwords.Password;
      this.changePassword.UserId = this._route.snapshot.params["id"];
      this.changePassword.IsSelfPwdUpdate = false;
      this._http
        .post(this._appUrl.UpdatePassword, this.changePassword)
        .subscribe(
          (data) => {
            this._mApp.HideLoader();
            this.reasetPasswordForm.reset();
            this._toastrService.success("Password updated successfully.", "");
            $("#resetPasswordModel").hide();
          },
          (error) => {
            this._mApp.HideLoader();
            this._toastrService.error(error.json().Result, "");
          },
        );
    }
  }
  setDefaultCompany(companyId: number, companyName: string) {
    this.filteredCompanyData.DefaultCompanyId = companyId;
    this.filteredCompanyData.DefaultCompanyName = companyName;
    // this.userForm.controls["DefaultCompanyId"].setValue(companyId);
    // Dismiss the modal after selection
    // $("#changeDefaultCompany").modal("hide");
  }
  clearSearch() {
    this.companySearchText = "";
    this.filteredCompanyData.Company = this.selectedCompanyData.Company;
  }
  filterCompanies() {
    if (!this.companySearchText || this.companySearchText.trim() === "") {
      return this.filteredCompanyData.Company;
    }
    this.filteredCompanyData.Company = this.selectedCompanyData.Company.filter((company: any) =>
      company.CompanyName.toLowerCase().includes(this.companySearchText.toLowerCase())
    );
  }
  ConfirmDialogue() {
    if (this.filteredCompanyData.DefaultCompanyId === 0 && this.filteredCompanyData.Company.length > 0) {
      this.showCompanyErrorMsg = true;
    }
    else {
      this.userForm.controls["DefaultCompanyId"].setValue(this.filteredCompanyData.DefaultCompanyId);
      $('#changeDefaultCompany').modal('hide');
      this.showCompanyErrorMsg = false;
    }
  }
  CancelDialgue() {
    $('#changeDefaultCompany').modal('hide');
    this.showCompanyErrorMsg = false;
    this.filteredCompanyData.DefaultCompanyId = this.selectedCompanyData.DefaultCompanyId;
    this.filteredCompanyData.DefaultCompanyName = this.selectedCompanyData.DefaultCompanyName;
    this.companySearchText = "";
    this.filteredCompanyData.Company = this.selectedCompanyData.Company;
  }

  // GetUserById(id) {
  //   this._mApp.ShowLoader();
  //   this._http.get(this._appUrl.GetUserByUserId + id)
  //     .subscribe(
  //       data => {
  //         if (data.json().Result != null) {
  //           this.userForm.setValue(data.json().Result)
  //         }
  //         this._mApp.HideLoader();
  //       },
  //       error => {
  //         this._mApp.HideLoader();
  //         this._toastrService.error(error.json().Result, '')
  //       }
  //     )
  // }
}
